import type cazhboxId from "./id";

const cazhboxEn: typeof cazhboxId = {
	cazhbox: {
		title: "Cazhbox",
		subtitle: "Cazhbox data summary",
		tabs: {
			cazhbox: "Cazhbox",
			transaction: "Transactions",
		},
		list: {
			title: "Cazhbox Data",
			empty_state: {
				title: "No cazhbox data",
				description: "Please add a new cazhbox.",
			},
			summary: {
				partner: "Partner Cazhbox",
				total_all_stores: "Total Cazhbox All Stores",
			},
			columns: {
				store: "Store",
				level: "Level",
				account_no: "Account Number",
				limit: "Limit",
				balance: "Balance",
			},
		},
		transaction: {
			title: "Transaction Data",
			empty_state: {
				title: "No transaction data",
				description: "No transactions in this period.",
			},
			filters: {
				account: "Account",
				all_accounts: "All Accounts",
				partner_tag: "(Partner)",
				store_tag: "(Store)",
				type: "Transaction Type",
				all_types: "All Transactions",
				transfer: "Transfer",
				topup: "Topup",
				redeem: "Redeem",
			},
			columns: {
				date: "Date",
				ref_id: "Ref ID",
				type: "Transaction Type",
				account: "Account",
				description: "Description",
				opening_balance: "Opening Balance",
				amount: "Amount",
				closing_balance: "Closing Balance",
				status: "Status",
			},
			status: {
				success: "Success",
				failed: "Failed",
			},
		},
		topup_modal: {
			trigger: "Top Up",
			title: "Top Up Partner Cazhbox Balance",
			instruction: "Please transfer to the following bank account:",
			bank_label: "Bank",
			virtual_account_suffix: "(Virtual Account)",
			account_name: "Account Name",
			account_no: "Account Number",
			how_to: "How to Top Up",
		},
		withdraw_modal: {
			trigger: "Withdraw",
			title: "Withdraw Partner Cazhbox Balance",
			instruction: "Please transfer to the following bank account:",
			select_placeholder: "Select Bank",
			notes: {
				settlement:
					"Some banks take 2-3 business days of settlement time before the balance is credited to your account.",
				after_hours:
					"Transactions above 100 million made after 14:00 on business days will be processed on the next business day.",
				holiday:
					"Transactions above 100 million made on holidays will be processed on the next business day.",
				banking_hours: "These rules follow banking operational hours.",
			},
			cancel: "Cancel",
			ok: "OK",
		},
	},
};

export default cazhboxEn;
